import Component from '../lib/Component'
import gsap from 'gsap'
import { addClass, removeClass } from '../lib/Utils'

export default class Navigation extends Component {
	constructor() {
		super('.js-nav-trigger')
	}

	initialize() {
		this.navTrigger = this.$el
		this.navigation = document.querySelector('.js-navigation')
		this.navigationItem = this.navigation.querySelectorAll(
			'.js-navigation-item',
		)
		this.closeButton = this.navigation.querySelector('.js-navigation-close')
		this.otherElements = this.navigation.querySelectorAll(
			'.js-navigation-close-wrapper, .js-marquee-text, .js-navigation-social',
		)
		this.navigationStage = document.querySelectorAll('.js-navigation-stage')
		this.navigationLink = this.navigation.querySelectorAll(
			'.js-navigation-link',
		)
		this.navigationBgCover = this.navigation.querySelector(
			'.js-navigation-bg-cover',
		)
		this.navigationWidget = this.navigation.querySelectorAll('.c-widget')

		this.initClicks()
		this.initEscButton()
	}

	initClicks() {
		this.navTrigger.addEventListener('click', (ev) => {
			ev.preventDefault()
			ev.currentTarget.classList.contains('is-opened')
				? this.closeMenu()
				: this.openMenu()
		})

		for (var i = 0; i < this.navigationLink.length; i++) {
			this.navigationLink[i].addEventListener('click', (ev) => {
				if (ev.currentTarget.classList.contains('is-active')) {
					ev.preventDefault()

					this.closeMenu()
				} else {
					this.closeMenu()
				}
			})
		}

		this.closeButton.addEventListener('click', (ev) => {
			if (this.navTrigger.classList.contains('is-opened')) {
				this.closeMenu()
			}
		})
	}

	initEscButton() {
		document.addEventListener('keydown', (ev) => {
			if (
				ev.keyCode === 27 &&
				this.navTrigger.classList.contains('is-opened')
			) {
				this.closeMenu()
			}
		})
	}

	openMenu() {
		const openNavTL = gsap.timeline({
			onStart: () => {
				gsap.to(
					this.navigationStage,
					0.3,
					{
						autoAlpha: 0,
						ease: 'none.none',
					},
					0.05,
				)
			},
		})

		openNavTL
			.add('start')
			.to(this.navigation, 0.6, {
				x: '0%',
				ease: 'expo.inOut',
				onStart: () => {
					addClass(this.navTrigger, 'is-disabled')
				},
				onComplete: () => {
					addClass('body', 'is-navigation-opened')
					removeClass(this.navTrigger, 'is-disabled')
					addClass(this.navigation, 'is-opened')
					addClass(this.navTrigger, 'is-opened')
				},
			})
			.to(
				this.navigationBgCover,
				0.8,
				{
					x: '-100%',
					ease: 'expo.inOut',
					delay: 0.6,
				},
				'start',
			)
			.fromTo(
				this.navigationItem,
				0.3,
				{
					autoAlpha: 0,
					y: '50%',
					skewY: '-3deg',
				},
				{
					autoAlpha: 1,
					y: '0%',
					skewY: '0deg',
					ease: 'expo.out',
					stagger: 0.05,
				},
				'start, -=0.7',
			)
			.fromTo(
				this.navigationWidget,
				0.2,
				{
					autoAlpha: 0,
					y: '25%',
					skewY: '-1.5deg',
					ease: 'expo.inOut',
				},
				{
					autoAlpha: 1,
					y: '0%',
					skewY: '0deg',
					ease: 'expo.out',
					stagger: 0.05,
				},
				'start, -=0.4',
			)
			.fromTo(
				this.otherElements,
				0.3,
				{
					autoAlpha: 0,
				},
				{
					autoAlpha: 1,
					ease: 'expo.out',
				},
				'start, -=0.2',
			)
	}

	closeMenu = () => {
		const closeNavTL = gsap.timeline({
			onStart: () => {
				addClass(this.navTrigger, 'is-disabled')
				removeClass('body', 'is-navigation-opened')
				removeClass(this.navTrigger, 'is-opened')
			},
			onComplete: () => {
				removeClass(this.navTrigger, 'is-disabled')
			},
		})

		closeNavTL
			.add('start')
			.fromTo(
				this.navigationBgCover,
				0.6,
				{
					x: '100%',
				},
				{
					x: '0%',
					ease: 'expo.inOut',
					onComplete: () => {
						gsap.to(this.navigationStage, 0.4, {
							autoAlpha: 1,
							delay: 0.4,
							ease: 'none.none',
							onComplete: () => {
								gsap.set(this.navigationStage, {
									clearProps: 'all',
								})
							},
						})
					},
				},
				'start',
			)
			.fromTo(
				this.navigationItem,
				0.2,
				{
					autoAlpha: 1,
					y: '0%',
				},
				{
					autoAlpha: 0,
					y: '-50%',
					ease: 'expo.in',
					stagger: 0.03,
				},
				'start',
			)
			.fromTo(
				this.navigationWidget,
				0.2,
				{
					autoAlpha: 1,
					y: '0%',
				},
				{
					autoAlpha: 0,
					y: '-50%',
					ease: 'expo.in',
					stagger: 0.03,
				},
				'start',
			)
			.fromTo(
				this.otherElements,
				0.2,
				{
					autoAlpha: 1,
				},
				{
					autoAlpha: 0,
					ease: 'expo.in',
				},
				'start',
			)
			.add('afterStart')
			.to(
				this.navigation,
				0.4,
				{
					autoAlpha: 0,
					onComplete: () => {
						gsap.set([this.navigation, this.navigationBgCover], {
							clearProps: 'all',
						})

						removeClass(this.navigation, 'is-opened')
					},
				},
				'afterStart',
			)
	}
}
